import { useBusinessOptions } from '@/services/businessOptions'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faClipboardList, faClockRotateLeft, faFilter, faMapLocationDot, faUsers } from '@fortawesome/free-solid-svg-icons'

export const reportCards = [
  { slug: 'submissions', title: 'Submissions', description: 'Successful actions with their linked submissions and saved order details.', icon: faClipboardList },
  { slug: 'direct-submissions', title: 'Direct submissions', description: 'Submissions raised directly, without an originating action.', icon: faClipboardList },
  { slug: 'grid', title: 'Customer grid references', description: 'See how customers are distributed across your grid references.', icon: faMapLocationDot },
  { slug: 'filtered', title: 'Customer filter search', description: 'Find accounts using customer, ownership and delivery filters.', icon: faFilter },
  { slug: 'sales', title: 'Rep action log', description: 'Review actions completed and notes added by each team member.', icon: faUsers },
  { slug: 'last-action', title: 'Customer last action', description: 'Find customers who have not had a completed action recently.', icon: faClockRotateLeft },
] as const

export function ReportCards() {
  const { options: businessOptions } = useBusinessOptions()
  return (
    <ul className="report-card-grid" aria-label="Available reports">
      {reportCards.filter(report => report.slug !== "grid" || businessOptions.useGridReferences).map(report => (
        <li key={report.slug}>
          <Link className="report-card" to={`/reports/${report.slug}`}>
            <span className="report-card__icon" aria-hidden="true"><FontAwesomeIcon icon={report.icon} /></span>
            <div className="report-card__content">
              <h2>{report.title}</h2>
              <p>{report.description}</p>
              <span className="report-card__link">Open report <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" /></span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  )
}
